// extracted by mini-css-extract-plugin
module.exports = {"tooltipPoint":"tooltip_tooltipPoint__1vQ5s","tooltipIcon":"tooltip_tooltipIcon__1IwrS","toolBlock":"tooltip_toolBlock__2E6yu"};